module.exports = {
  apps: [
    {
      name: "sura-cotizadores",
      script: "./server/index.js",
      env: {
        NODE_ENV: "development",
      },
      env_production: {
        NODE_ENV: "production",
        DEPLOY_PATH: "/SuraCotizadores"
      },
      isDev: true,
      reCaptcha: {
        enabled: false,
        sitekey: "6Le26JsUAAAAAOA8LQMS2SBIkF8_a8yv_7kSSrU8"
      }
    }
  ],
  suraConfig: {
    url: "https://test.segurossura.com.uy/Api",
    user: "rsalogin",
    pass: "Login*2015",
    domain: "AGENTES"
  },
  paramCodes: {
    codigoUsuario: 'WSASEG',
		codigoTipoAgente: '3', //broker
		codigoAgente: '3453',
    codigoAsegurado: '291157',
  },
  paramPymeCodes: {
    codigoUsuario: 'WSASEG',
    codigoTipoAgente: '1',
    codigoAgente: '9988',
    codigoAgencia: '1',
  },
  sendQuoteByEmail: {
    transporter: {
      user: "noresponder.segurossura@gmail.com",
      pass: "suraxseed@2016",
    },
    mailOptions: {
      from: '"Seguros Sura" <noresponder.segurossura@gmail.com>',
      toSura: "mcorso@xseed.com.uy,dcaceres@xseed.com.uy", //cotizaciones@segurossura.com.uy
    }
  },
  escritorioConfig: {
    //url: "http://localhost:5099/api", // Test
    url: "http://dev.xseed.com.uy/escritoriosura/services/api",
    user: "Xseed_Test",
    pass: "Xseed*2018",
    grant_type: "password"
  },
  paymentConfig: {
    //url: 'http://localhost:49799/Private/NewPayment?paymentData=', // Test
    url: 'http://dev.xseed.com.uy/EscritorioSura/Private/NewPayment?paymentData=',
    Defaut:         { red: false, debit: false, visa: false, master: false, oca: false },
    AutosSOA:       { red: false, debit: false, visa:  true, master: false, oca: false },
    AutosStandard:  { red:  true, debit: false, visa:  true, master: false, oca: false },
    AutosEconomico: { red:  true, debit: false, visa:  true, master: false, oca: false },
    Yates:          { red: false, debit: false, visa:  true, master:  true, oca: false },
    Pyme:           { red:  true, debit: false, visa:  true, master: false, oca: false },
    PymeFarmacia:   { red:  true, debit: false, visa:  true, master: false, oca: false },
    Hogar:          { red: false, debit: false, visa:  true, master: false, oca: false },
    APersonales:    { red: false, debit: false, visa:  true, master: false, oca: false },
  },
  quoters: {
    AUTOSSOA:       { enabled: true, key: 'AutosSOA',       title: 'Vehículos SOA'},
    AUTOSSTANDARD:  { enabled: true, key: 'AutosStandard',  title: 'Autos Standard'},
    AUTOSECONOMICO: { enabled: true, key: 'AutosEconomico', title: 'Autos Económico'},
    YATES:          { enabled: true, key: 'Yates',          title: 'Yates'},
    PYME:           { enabled: true, key: 'Pyme',           title: 'Pymes'},
    PYMEFARMACIA:   { enabled: true, key: 'PymeFarmacia',   title: 'Pymes Farmacias'},
    GTIAALQUILER:   { enabled: true, key: 'GtiaAlquiler',   title: 'Garantía de Alquiler'},
    HOGAR:          { enabled: true, key: 'Hogar',          title: 'Hogar'},
    APERSONALES:    { enabled: true, key: 'APersonales',    title: 'Accidentes Personales'},
    SALUD:          { enabled: false, key: 'Salud',  title: 'Salud'}
  }
};
